import PropTypes from 'prop-types';

export default {
  form: PropTypes.any,
};
